import React from 'react'
import Highlight from '@paintscout/ui/components/Highlight'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityFooter from '../ActivityFooter'
import ActivityOwner from '../ActivityOwner'
import ActivityTitle from '../ActivityTitle'
import QuoteActivitySubtitle from '../QuoteActivitySubtitle'
import QuoteLabel from '../QuoteLabel'

export default function QuoteTypeChangedActivity(props: ActivityTypeComponentProps) {
  const { activity, showDocTypeDetails } = props

  return (
    <>
      <ActivityTitle>
        {showDocTypeDetails ? (
          <>
            <QuoteLabel activity={activity} /> <Highlight>Type </Highlight>changed
          </>
        ) : (
          <>
            <Highlight>Type </Highlight>changed
          </>
        )}
        <ActivityOwner activity={activity} />
      </ActivityTitle>
      <QuoteActivitySubtitle activity={activity} showDocTypeDetails={showDocTypeDetails} />
      <ActivityFooter timestamp={activity.details.timestamp} />
    </>
  )
}
